var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { MFCalculatorTabsEmum, stepupWithTotalMaxPercent, } from "@frameworks/web/components/features/Markets/MutualFunds/constant";
import { MFCalculatorInvestmentTypeEmum } from "@frameworks/web/components/features/Quotes/MutualFunds/constants";
export var mfCalculationExicuters = function (amount, expectedMFReturn, timePeriod, expectedFDReturn, segmentType, investmentType, stepup, stepupPercent) {
    return investmentType === MFCalculatorInvestmentTypeEmum.ONE_TIME_LUMPSUM
        ? lumsumCalculator(amount, expectedMFReturn, timePeriod, expectedFDReturn, segmentType)
        : sipCalculate(amount, expectedMFReturn, timePeriod, expectedFDReturn, segmentType, stepup, stepupPercent);
};
export var lumsumCalculator = function (amount, expectedMFReturn, timePeriod, expectedFDReturn, segmentType) {
    var mfINPercent = expectedReturnINPercent(expectedMFReturn);
    var fdINPercent = expectedReturnINPercent(expectedFDReturn);
    var totalMFAmount = calculateLumsumTotalAmount(amount, mfINPercent, timePeriod, segmentType);
    var totalFDAmount = calculateLumsumTotalAmount(amount, fdINPercent, timePeriod, segmentType);
    return {
        screen: segmentType,
        totalMFAmount: totalMFAmount,
        totalFDAmount: totalFDAmount,
        investedAmount: amount,
        totalMFGain: totalMFAmount - parseFloat(amount),
        totalFDGain: totalFDAmount - parseFloat(amount),
        difference: totalMFAmount - totalFDAmount,
    };
};
export var sipCalculate = function (amount, expectedMFReturn, timePeriod, expectedFDReturn, segmentType, stepup, stepupPercent) {
    var mfINPercent = expectedReturnINPercent(expectedMFReturn);
    var fdINPercent = expectedReturnINPercent(expectedFDReturn);
    var totalMonths = countMonths(timePeriod);
    var nominalMFRetrun = calculateNominalReturn(mfINPercent) / 12;
    var nominalFDRetrun = calculateNominalReturn(fdINPercent) / 12;
    if (stepup) {
        return calculateSipWithStepup(amount, nominalMFRetrun, nominalFDRetrun, totalMonths, segmentType, stepupPercent);
    }
    else {
        var totalMFAmount = calculateSipTotalAmount(amount, nominalMFRetrun, totalMonths, segmentType);
        var totalFDAmount = calculateSipTotalAmount(amount, nominalFDRetrun, totalMonths, segmentType);
        return {
            screen: segmentType,
            totalMFAmount: totalMFAmount,
            totalFDAmount: totalFDAmount,
            investedAmount: parseFloat(amount) * totalMonths,
            totalMFGain: totalMFAmount - parseFloat(amount) * totalMonths,
            totalFDGain: totalFDAmount - parseFloat(amount) * totalMonths,
            difference: totalMFAmount - totalFDAmount,
        };
    }
};
export var calculateLumsumTotalAmount = function (amount, percent, time, segmentType) {
    var calculation = Math.pow(1 + percent, parseFloat(time));
    return segmentType === MFCalculatorTabsEmum.BY_INVESTMENT_AMOUNT
        ? Math.round(parseFloat(amount) * calculation)
        : Math.round(parseFloat(amount) / calculation);
};
export var calculateSipTotalAmount = function (amount, percent, totalMonths, segmentType) {
    var calculation = ((Math.pow(1 + percent, totalMonths) - 1) / percent) * (1 + percent);
    return segmentType === MFCalculatorTabsEmum.BY_INVESTMENT_AMOUNT
        ? Math.round(parseFloat(amount) * calculation)
        : Math.round(parseFloat(amount) / calculation);
};
export var calculateSipWithStepup = function (amount, nominalMFRetrun, nominalFDRetrun, totalMonths, segmentType, stepupPercent) {
    var totalMFAmount = segmentType === MFCalculatorTabsEmum.BY_INVESTMENT_AMOUNT
        ? calculateInvestSipWithStepup(amount, nominalMFRetrun, totalMonths, stepupPercent)
        : calculateTargetSipWithStepup(amount, nominalMFRetrun, totalMonths, stepupPercent);
    var totalFDAmount = segmentType === MFCalculatorTabsEmum.BY_INVESTMENT_AMOUNT
        ? calculateInvestSipWithStepup(amount, nominalFDRetrun, totalMonths, stepupPercent)
        : calculateTargetSipWithStepup(amount, nominalFDRetrun, totalMonths, stepupPercent);
    return {
        screen: segmentType,
        totalMFAmount: totalMFAmount.sipAmount ? totalMFAmount.sipAmount : totalMFAmount.totalReturn,
        totalFDAmount: totalFDAmount.sipAmount ? totalFDAmount.sipAmount : totalFDAmount.totalReturn,
        investedAmount: totalMFAmount.totalInvest,
        totalMFGain: totalMFAmount.totalGain,
        totalFDGain: totalFDAmount.totalGain,
        difference: totalMFAmount.totalReturn - totalFDAmount.totalReturn,
    };
};
export var calculateInvestSipWithStepup = function (amount, percent, totalMonths, stepupPercent) {
    var amounts = parseFloat(amount);
    var totalReturn = 0;
    var totalInvest = 0;
    for (var i = 1; i <= totalMonths; i++) {
        totalReturn =
            ((Math.pow(1 + percent, 1) - 1) / percent) *
                (1 + percent) *
                (amounts + Math.round(totalReturn));
        totalInvest += amounts;
        if (i % 12 === 0) {
            amounts = amounts + (parseFloat(stepupPercent) / 100) * amounts;
        }
    }
    return {
        totalReturn: Math.round(totalReturn),
        totalInvest: Math.round(totalInvest),
        totalGain: Math.round(totalReturn - totalInvest),
    };
};
export var calculateTargetSipWithStepup = function (amount, percent, totalMonths, stepupPercent) {
    var amounts = parseFloat(amount);
    var calculation = Math.round(amounts / (((Math.pow(1 + percent, totalMonths) - 1) / percent) * (1 + percent)));
    var getSipAmount = Math.round((calculation / 100) * 50);
    var isVaild = true;
    var getTotalAmount = 0;
    while (isVaild) {
        getTotalAmount = calculateInvestSipWithStepup(getSipAmount.toString(), percent, totalMonths, stepupPercent);
        if (getTotalAmount.totalReturn < amounts) {
            getSipAmount += Math.round((getSipAmount / 100) * 50);
        }
        else if (getTotalAmount.totalReturn > amounts + (amounts / 100) * stepupWithTotalMaxPercent) {
            getSipAmount -= Math.round((getSipAmount / 100) * 50);
        }
        else {
            isVaild = false;
        }
    }
    return __assign({ sipAmount: getSipAmount }, getTotalAmount);
};
export var expectedReturnINPercent = function (expectedFDReturn) {
    return parseFloat(expectedFDReturn) / 100;
};
export var calculateNominalReturn = function (percent) {
    return 12 * (Math.pow(1 + percent, 1 / 12) - 1);
};
export var countMonths = function (years) {
    return parseFloat(years) * 12;
};
export var getValidatedInstallmentForSIPMandate = function (expiryDate, sipDate, frequency) {
    var differenceBetweenDates = new Date(expiryDate).getTime() - new Date(sipDate).getTime();
    var DifferenceInDays = Math.trunc(differenceBetweenDates / (1000 * 60 * 60 * 24));
    var validatedInstallmentsForSIP = 0;
    switch (frequency) {
        case "MONTHLY":
            validatedInstallmentsForSIP = Math.floor(DifferenceInDays / 30);
            break;
        case "QUARTERLY":
            validatedInstallmentsForSIP = Math.floor(DifferenceInDays / 90);
            break;
        case "ANNUALLY":
            validatedInstallmentsForSIP = Math.floor(DifferenceInDays / 365);
            break;
        default:
            validatedInstallmentsForSIP = Math.floor(DifferenceInDays / 90);
    }
    return validatedInstallmentsForSIP;
};
